var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.493 25.753L24.34 16 7.493 6.247v19.506zM7.99 4.225c-1.107-.64-2.49.162-2.49 1.445v20.66c0 1.283 1.383 2.086 2.49 1.445l17.846-10.33c1.108-.642 1.108-2.248 0-2.89L7.99 4.226z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }